import { render } from "./TotalSupplier.vue?vue&type=template&id=c709bc04"
import script from "./TotalSupplier.vue?vue&type=script&lang=js"
export * from "./TotalSupplier.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__